import { useState, useEffect } from "react";
import DataTable from "../../components/common/DataTable";
import Select from "../../components/common/Select";
import { getSupportTicketsDashboard, getSupportFormData, fetchSupportTransaction, submitSupportTicket, getSupportTickets } from "../../services/supportService";

const complaints = [
  {
    id: "CMP260402MY", date: "Apr 26, 14:32", category: "PAYOUT", categoryColor: "bg-violet-100 text-[#34094D]",
    reason: "Amount debited but ...", status: "IN PROGRESS", amount: "2,450.00",
  },
  {
    id: "CMP2603275U", date: "Mar 26, 09:15", category: "PAYOUT", categoryColor: "bg-violet-100 text-[#34094D]",
    reason: "Refund not credited t...", status: "RESOLVED", amount: "12,800.00",
  },
  {
    id: "CMP260315LK", date: "Mar 15, 16:45", category: "ONBOARD", categoryColor: "bg-blue-100 text-[#1D4ED8]",
    reason: "KYC documents veri...", status: "RESOLVED", amount: "—",
  },
  {
    id: "CMP260312XC", date: "Mar 12, 11:20", category: "SETTLE", categoryColor: "bg-orange-100 text-[#EA580C]",
    reason: "Settlement delayed f...", status: "RESOLVED", amount: "$45,210.00",
  },
];

const statusConfig = {
  "IN PROGRESS": { text: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200", dot: "bg-amber-400" },
  RESOLVED: { text: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", dot: "bg-emerald-400" },
};

const stats = [
  {
    label: "TOTAL TICKETS", value: "44", sub: "+12% from last month", subColor: "text-emerald-500",
    icon: (
      <svg className="w-6 h-6 text-violet-500" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: "ACTIVE OPEN", value: "0", sub: "All current issues assigned", subColor: "text-gray-400",
    icon: (
      <svg className="w-6 h-6 text-red-400" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: "IN PROGRESS", value: "2", sub: "Avg resolution: 18.5 hrs", subColor: "text-gray-400",
    icon: (
      <svg className="w-6 h-6 text-orange-400" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: "RESOLVED", value: "42", sub: "95.4% satisfaction rate", subColor: "text-gray-400",
    icon: (
      <svg className="w-6 h-6 text-emerald-500" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const SearchIcon = () => (
  <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" strokeLinecap="round" />
  </svg>
);

const ChevronDown = () => (
  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path d="M6 9l6 6 6-6" strokeLinecap="round" />
  </svg>
);

const FilterIcon = () => (
  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path d="M3 4h18M7 12h10M10 20h4" strokeLinecap="round" />
  </svg>
);

const DownloadIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 4v12m-4-4l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PlusIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path d="M12 5v14M5 12h14" strokeLinecap="round" />
  </svg>
);

const TRANSACTION_TYPES = ["Payout", "Payin", "Settlement", "Refund"];

function RaiseComplaint({ onBack }) {
  const [txnId, setTxnId] = useState("");
  const [txnType, setTxnType] = useState("");
  const [txnFound, setTxnFound] = useState(null);
  const [lookupDone, setLookupDone] = useState(false);
  const [service, setService] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    getSupportFormData()
      .then((res) => setSubjects(res.data?.data?.subjects || []))
      .catch(() => {});
  }, []);

  const handleSubmit = async () => {
    if (!txnFound) return;
    if (!category) { setSubmitError("Please select a complaint reason."); return; }
    if (!description.trim()) { setSubmitError("Please enter a description."); return; }
    setSubmitLoading(true);
    setSubmitError(null);
    setSubmitSuccess(null);
    try {
      const res = await submitSupportTicket({
        transactionId: txnFound.id,
        subject:       category,
        description:   description.trim(),
        files,
      });
      const d = res.data?.data;
      setSubmitSuccess(`Ticket #${d?.ticket_id?.slice(0, 8).toUpperCase()} submitted successfully!`);
      setTimeout(() => onBack(), 2000);
    } catch (err) {
      setSubmitError(err.response?.data?.message || "Submission failed. Please try again.");
    } finally {
      setSubmitLoading(false);
    }
  };

  const [lookupLoading, setLookupLoading] = useState(false);

  const handleLookup = async () => {
    if (!txnId.trim()) return;
    setLookupLoading(true);
    setLookupDone(false);
    setTxnFound(null);
    try {
      const res = await fetchSupportTransaction(txnId.trim());
      const d = res.data?.data;
      if (d) {
        setTxnFound({
          id:          d.transaction_id,
          reference:   d.reference_id,
          date:        d.created_at ? new Date(d.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—",
          amount:      d.amount ? `₹${parseFloat(d.amount).toLocaleString("en-IN")}` : "—",
          status:      d.status,
          type:        d.service,
        });
      } else {
        setTxnFound(null);
      }
    } catch {
      setTxnFound(null);
    } finally {
      setLookupDone(true);
      setLookupLoading(false);
    }
  };

  return (
    <div className="flex-1 px-8 py-7 overflow-y-auto">
      {/* Page Title */}
      <div className="flex items-center gap-3 mb-2">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center transition-colors cursor-pointer">
          <svg className="w-7 h-7 text-[#4B2364]" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
            <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <div>
          <h1 className="text-[36px] font-extrabold text-[#4B2364] leading-tight">Raise Complaint</h1>
        </div>
      </div>
      <p className="text-[18px] text-[#4C444E] font-medium pl-3">Start by finding the transaction related to your issue. Providing a reference helps us locate
        the record immediately.</p>

      {/* Step indicators */}
      <div className="flex items-center gap-3 mb-7 mt-5">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-full bg-gradient-to-br from-[#754F89] to-[#4B2364] flex items-center justify-center text-white text-[12px] font-bold">1</div>
          <span className="text-[13px] font-bold text-[#34094D]">Transaction Lookup</span>
        </div>
        <div className="flex-1 h-px bg-[#E5E7EB] max-w-[60px]" />
        <div className="flex items-center gap-2">
          <div className={`w-7 h-7 rounded-full flex items-center justify-center text-[12px] font-bold ${txnFound ? "bg-gradient-to-br from-[#754F89] to-[#4B2364] text-white" : "bg-[#F3F4F5] text-[#7D747F]"
            }`}>2</div>
          <span className={`text-[13px] font-bold ${txnFound ? "text-[#34094D]" : "text-[#7D747F]"}`}>Complaint Submission</span>
        </div>
      </div>

      <div className="space-y-5">
        {/* Step 1 — Transaction Lookup */}
        <div className="bg-white rounded-[16px] px-6 py-[28px] border border-[#E1E3E480] shadow-[0px_1px_2px_0px_#0000000D] overflow-hidden">
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 flex items-center justify-center">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
              </svg>
            </div>
            <div>
              <p className="text-[20px] font-semibold text-[#34094D]">Step 1: Find Transaction</p>
            </div>
          </div>
          <div className="p-2 w-3/4 block">
            <div className="grid grid-cols-4 block gap-4 mb-4 items-end">
              <div className="col-span-3">
                <label className="text-[14px] font-semibold text-[#4C444E] uppercase tracking-wider mb-1.5">Transaction ID / Reference Number</label>
                <input
                  value={txnId}
                  onChange={e => { setTxnId(e.target.value); setLookupDone(false); setTxnFound(null); }}
                  placeholder="# TXN-45920-ZM"
                  className="w-full bg-[#F3F4F5] rounded-[24px] border border-[#CEC3D0] px-[20px] py-[12px] text-[16px] text-[#191C1D] outline-none focus:ring-1 focus:ring-[#4B2364]/30 placeholder:text-[#7D747F66] transition-all"
                />
              </div>
              <div>
                <button
                  onClick={handleLookup}
                  disabled={lookupLoading}
                  className="flex items-center gap-2 text-[13px] font-bold text-white bg-[#34094D] px-[28px] py-[16px] rounded-[24px] border-none cursor-pointer hover:opacity-90 transition-all shadow-[0px_4px_12px_rgba(75,35,100,0.25)] disabled:opacity-60"
                >
                  {lookupLoading ? "Searching..." : "Fetch Record"}
                  {!lookupLoading && (
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 12a9 9 0 11-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
                      <path d="M21 3v5h-5" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
          {/* Result */}
          {lookupDone && !txnFound && (
            <div className="mt-4 flex items-center gap-2 bg-red-50 border border-red-100 rounded-[12px] px-4 py-3">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" /></svg>
              <p className="text-[12px] font-semibold text-red-600">No transaction found with this ID. Please check and try again.</p>
            </div>
          )}

          {txnFound && (
            <div className="mt-2 bg-[#FAF5FF] rounded-[24px] border border-[#F3E8FF] p-6">
              <div className="grid grid-cols-4 gap-4">
                {[
                  { label: "Status",         value: txnFound.status },
                  { label: "Amount",         value: txnFound.amount },
                  { label: "Service",        value: txnFound.type },
                  { label: "Date & Time",    value: txnFound.date },
                ].map(f => (
                  <div key={f.label}>
                    <p className="text-[12px] font-semibold text-[#C084FC] uppercase tracking-wider mb-1">{f.label}</p>
                    <p className="text-[13px] font-semibold text-[#191C1D] truncate">{f.value}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Step 2 — Complaint Submission */}
        <div className={`overflow-hidden transition-all ${txnFound ? "" : "opacity-40 pointer-events-none"
          }`}>

          {/* Two-column body */}
          <div className="grid grid-cols-5 gap-6">

            {/* LEFT — Reason Selection */}
            <div className="col-span-2 p-7 bg-[#F3F4F5] border border-[#E1E3E480] rounded-[16px] shadow-[0px_1px_2px_0px_#0000000D] flex flex-col">
              {/* Card Title */}
              <div className="mb-5 px-1">
                <p className="text-[20px] font-semibold text-[#34094D]">
                  Step 2: Complaint Reason
                  <span className="text-[#4B2364] ml-0.5">*</span>
                </p>
              </div>

              {/* Radio List */}
              <div className="flex flex-col gap-3">
                {subjects.length === 0 ? (
                  <p className="text-[13px] text-[#9B8FA0] px-1">Loading...</p>
                ) : subjects.map((label) => {
                  const isSelected = service === label;
                  return (
                    <button
                      key={label}
                      onClick={() => setService(label)}
                      className={`w-full flex items-center gap-3 px-4 py-4 rounded-[16px] text-left transition-all cursor-pointer ${isSelected
                          ? "bg-[#FAF5FF] border border-[#CFA9F3]"
                          : "bg-white border border-transparent"
                        }`}
                    >
                      <div
                        className={`w-[20px] h-[20px] rounded-full bg-[#EDEEEF] flex items-center justify-center border-2 transition-all
                          ${isSelected ? "border-[#5B2A86]" : "border-[#CEC3D0]"}`}
                      >
                        {isSelected && <div className="w-[10px] h-[10px] bg-[#5B2A86] rounded-full" />}
                      </div>
                      <p className="text-[15px] font-medium text-[#2D0A3A]">{label}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* RIGHT — Complaint Description */}
            <div className="col-span-3 p-7 flex flex-col gap-6 bg-white rounded-2xl shadow-sm">

              {/* Description */}
              <div className="flex flex-col gap-2">
                <label className="block text-[16px] font-semibold text-[#34094D] uppercase  mb-2">
                  Complaint Description
                </label>
                <textarea
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  rows={5}
                  placeholder="Explain what happened..."
                  className="w-full bg-[#F3F4F5] rounded-[24px] border border-[#CEC3D0] px-4 py-3.5 text-[14px] text-[#191C1D] outline-none focus:ring-1 focus:ring-[#4B2364]/20 focus:border-[#4B2364]/30 placeholder:text-[#C4B8CC] resize-none transition-all leading-relaxed"
                />
              </div>

              {/* Attach Proof */}
              <div>
                <div className="mb-3">
                  <p className="text-[20px] font-bold text-[#34094D]">
                    Attach Proof
                    <span className="ml-1.5 text-[14px] font-regular text-[#94A3B8]">
                      (Optional)
                    </span>
                  </p>
                  <p className="text-[12px] text-[#4C444E]">
                    Upload JPG, PNG or jpeg
                  </p>
                </div>

                <div className="flex flex-wrap gap-3">

                  {/* Files */}
                  {files.map((f, i) => (
                    <div
                      key={i}
                      className="relative w-[64px] h-[64px] rounded-xl overflow-hidden border border-[#E1E3E4] bg-[#F9FAFB] group"
                    >
                      {f.type.startsWith("image/") ? (
                        <img
                          src={URL.createObjectURL(f)}
                          alt={f.name}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full flex flex-col items-center justify-center gap-1">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4B2364" strokeWidth="1.8">
                            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                          </svg>
                          <p className="text-[8px] font-semibold text-[#4B2364] uppercase truncate w-full text-center px-1">
                            {f.name.split(".").pop()}
                          </p>
                        </div>
                      )}

                      {/* Remove */}
                      <button
                        onClick={() => setFiles(prev => prev.filter((_, idx) => idx !== i))}
                        className="absolute top-1 right-1 w-5 h-5 rounded-full bg-[#34094D] flex items-center justify-center opacity-0 group-hover:opacity-100 transition"
                      >
                        <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                          <path d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ))}

                  {/* Add Button */}
                  <label className="w-[64px] h-[64px] rounded-xl border-2 border-dashed border-[#D1D5DB] bg-[#F9FAFB] flex flex-col items-center justify-center cursor-pointer hover:border-[#4B2364] hover:bg-[#FAF5FF] transition group">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9B8FA0" strokeWidth="2.5" className="group-hover:stroke-[#4B2364] transition">
                      <path d="M12 5v14M5 12h14" />
                    </svg>
                    <input
                      type="file"
                      className="hidden"
                      accept=".jpg,.jpeg,.png"
                      multiple
                      onChange={e => {
                        const picked = Array.from(e.target.files || []);
                        setFiles(prev => [...prev, ...picked]);
                        e.target.value = "";
                      }}
                    />
                  </label>

                </div>
              </div>

              {/* Error / Success */}
              {submitError && (
                <div className="flex items-center gap-2 bg-red-50 border border-red-100 rounded-[12px] px-4 py-3">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/></svg>
                  <p className="text-[12px] font-semibold text-red-600">{submitError}</p>
                </div>
              )}
              {submitSuccess && (
                <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-100 rounded-[12px] px-4 py-3">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  <p className="text-[12px] font-semibold text-emerald-600">{submitSuccess}</p>
                </div>
              )}

              {/* Submit Button */}
              <button
                onClick={handleSubmit}
                disabled={submitLoading || !!submitSuccess}
                className="mt-2 w-fit px-7 h-[46px] rounded-full text-white text-[15px] font-semibold bg-[linear-gradient(101.82deg,#EA8534_0%,#A0111A_100%)] flex items-center gap-2 shadow-sm hover:opacity-95 transition disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {submitLoading ? "Submitting..." : submitSuccess ? "Submitted ✓" : "Submit Complaint"}
                {!submitLoading && !submitSuccess && <span className="text-lg">➤</span>}
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default function ComplaintsDashboard() {
  const [view, setView] = useState("dashboard");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [status, setStatus] = useState("All Status");
  const [service, setService] = useState("All Services");
  const [dashStats, setDashStats] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [loadingTickets, setLoadingTickets] = useState(true);

  const normalizePagination = (raw, fallbackPage, fallbackLimit, rowCount) => {
    const p = raw || {};
    const current = Number(p.current_page ?? p.page) || fallbackPage;
    const total = Number(p.total) || 0;
    const lastByTotal = total > 0 ? Math.ceil(total / fallbackLimit) : 0;
    const last = Number(p.last_page ?? p.total_pages) || lastByTotal || (rowCount === fallbackLimit ? current + 1 : current);
    return {
      current_page: current,
      last_page: Math.max(1, last),
      total,
      has_more: Boolean(p.has_more ?? current < Math.max(1, last)),
    };
  };

  // Reset page when filters change
  useEffect(() => {
    setPage(1);
  }, [status, service]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setSearch(searchInput.trim());
    }, 300);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    getSupportTicketsDashboard()
      .then((res) => setDashStats(res.data?.data))
      .catch(() => {});
  }, [view]);

  useEffect(() => {
    setLoadingTickets(true);
    getSupportTickets({
      status: status === "All Status" ? "" : status,
      service: service === "All Services" ? "" : service,
      search,
      page,
      limit: 10,
    })
      .then((res) => {
        const rows = res.data?.data?.tickets || [];
        const normalized = normalizePagination(res.data?.data?.pagination || res.data?.data?.meta, page, 10, rows.length);
        setTickets(rows);
        setPagination(normalized);
        setPage(normalized.current_page);
      })
      .catch(() => {})
      .finally(() => setLoadingTickets(false));
  }, [page, view, status, service, search]);

  const columns = [
    {
      accessorKey: "id",
      header: "Ticket ID",
      cell: (info) => {
        const row = info.row.original;
        return (
          <div>
            <p className="text-md font-bold text-gray-800">{info.getValue()}</p>
            <p className="text-sm text-gray-400 mt-0.5">{row.date}</p>
          </div>
        );
      },
    },
    {
      accessorKey: "reason",
      header: "Reason",
      cell: (info) => (
        <span className="text-sm text-gray-600">{info.getValue()}</span>
      ),
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: (info) => {
        const status = info.getValue();
        const s = statusConfig[status];
        return (
          <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${s.bg} ${s.text} ${s.border}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`}></span>
            {status}
          </span>
        );
      },
    },
    {
      accessorKey: "amount",
      header: "Amount",
      cell: (info) => (
        <span className="text-md font-semibold text-gray-800">{info.getValue()}</span>
      ),
    },
    {
      accessorKey: "id",
      header: "Actions",
      cell: () => (
        <button className="text-sm font-semibold text-violet-600 hover:text-violet-800 hover:underline transition-all">
          View
        </button>
      ),
    },
  ];

  return (
    <>
        {view === "raise" ? (
          <RaiseComplaint onBack={() => setView("dashboard")} />
        ) : (
          <div className="flex-1 px-8 py-7 overflow-y-auto">
            <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
              <div>
                <h1 className="text-[36px] font-bold text-[#34094D] mb-1.5">Complaints Dashboard</h1>
                <p className="text-[18px] text-[#4C444E] font-medium mt-1.5 max-w-md">
                  Centralized hub for managing all service resolutions. Monitor ticket status, analyze response metrics, and initiate new support requests.
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1">
                <button className="flex items-center gap-2 text-sm font-semibold text-[#191C1D] border border-gray-200 bg-[#E7E8E9] px-4 py-2.5 rounded-xl shadow-sm transition-all">
                  <DownloadIcon />
                  Export Report
                </button>
                <button onClick={() => setView("raise")} className="flex items-center gap-2 text-sm font-semibold text-white bg-[linear-gradient(101.98deg,#EA8534_0%,#A0111A_100%)] shadow-[0px_12px_24px_-8px_#EA853466] px-4 py-2.5 rounded-xl transition-all">
                  <PlusIcon />
                  Raise New Complaint
                </button>
              </div>
            </div>

            {/* Stat Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
              {[
                {
                  label: "Total Tickets", value: dashStats?.total_tickets ?? "—", sub: "All time tickets", subColor: "text-emerald-500",
                  iconBg: "bg-violet-50", iconColor: "text-violet-500",
                  icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" strokeLinecap="round" strokeLinejoin="round" /></svg>,
                },
                {
                  label: "Open", value: dashStats?.open_tickets ?? "—", sub: "Awaiting response", subColor: "text-gray-400",
                  iconBg: "bg-red-50", iconColor: "text-red-400",
                  icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" strokeLinecap="round" /></svg>,
                },
                {
                  label: "In Progress", value: dashStats?.in_progress_tickets ?? "—", sub: "Being worked on", subColor: "text-gray-400",
                  iconBg: "bg-orange-50", iconColor: "text-orange-400",
                  icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" /></svg>,
                },
                {
                  label: "Resolved", value: dashStats?.resolved_tickets ?? "—", sub: "Successfully closed", subColor: "text-emerald-500",
                  iconBg: "bg-emerald-50", iconColor: "text-emerald-500",
                  icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" strokeLinecap="round" strokeLinejoin="round" /></svg>,
                },
              ].map((s, i) => (
                <div key={i} className="bg-white rounded-[24px] p-6 shadow-[0px_8px_24px_0px_#4B23640A] border border-[#F0EBF4]">
                  <div className="flex items-center justify-between mb-4">
                    <div className={`w-10 h-10 rounded-[14px] flex items-center justify-center ${s.iconBg} ${s.iconColor}`}>
                      {s.icon}
                    </div>
                    <span className="text-[11px] font-bold text-[#7D747F] uppercase tracking-wider">{s.label}</span>
                  </div>
                  <p className="text-[32px] font-extrabold text-[#191C1D] leading-none mb-2">{s.value}</p>
                  <p className={`text-[12px] font-semibold ${s.subColor}`}>{s.sub}</p>
                </div>
              ))}
            </div>

            {/* Filter Bar */}
            <div className="bg-[#F3F4F5] p-5 rounded-[24px] mb-6">
              <div className="flex flex-wrap items-center justify-between gap-3">

                {/* Search */}
                <div className="flex items-center gap-3 bg-white rounded-[16px] px-4 py-3 flex-1 min-w-[220px] shadow-sm border border-[#F0EBF4]">
                  <SearchIcon />
                  <input
                    type="text"
                    placeholder="Search ticket ID or reason..."
                    className="text-[14px] text-[#191C1D] placeholder:text-[#7D747F99] outline-none bg-transparent w-full"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                  {searchInput && (
                    <button onClick={() => setSearchInput("")} className="text-[#7D747F] hover:text-[#191C1D] border-none bg-transparent cursor-pointer shrink-0">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <path strokeLinecap="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>

                <div className="flex items-center gap-3 flex-wrap">
                  {/* Status Filter */}
                   <div className="relative">
                    <Select
                      className="bg-white min-w-[150px] px-3 py-2.5 rounded-[12px] border border-[#F0EBF4] shadow-sm focus-within:ring-2 focus-within:ring-violet-300"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      options={[
                        { label: "All Status", value: "All Status" },
                        { label: "Open", value: "open" },
                        { label: "In Progress", value: "in_progress" },
                        { label: "Resolved", value: "resolved" },
                        { label: "Closed", value: "closed" },
                      ]}
                    />
                  </div>

                  {/* Category Filter */}
                   <div className="relative">
                    <Select
                      className="bg-white min-w-[170px] px-3 py-2.5 rounded-[12px] border border-[#F0EBF4] shadow-sm focus-within:ring-2 focus-within:ring-violet-300"
                      value={service}
                      onChange={(e) => setService(e.target.value)}
                      options={[
                        { label: "All Services", value: "All Services" },
                        { label: "Payout", value: "PAYOUT" },
                        { label: "Onboard", value: "ONBOARD" },
                        { label: "Settle", value: "SETTLE" },
                      ]}
                    />
                  </div>
                  {/* <button className="text-[#4C444E] bg-[#FFFFFF]  text-[13px] font-semibold px-5 py-2.5 rounded-[12px] border-none cursor-pointer hover:opacity-90 transition-opacity">
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 4h18M7 12h10M10 20h4" strokeLinecap="round" />
                    </svg>
                  </button> */}

                  {(searchInput || status !== "All Status" || service !== "All Services") && (
                    <button
                      onClick={() => { setSearchInput(""); setSearch(""); setStatus("All Status"); setService("All Services"); }}
                      className="text-[13px] font-semibold text-[#7D747F] hover:text-[#34094D] bg-transparent border-none cursor-pointer transition-colors"
                    >
                      Reset
                    </button>
                  )}
                </div>
              </div>

              {/* Active filter tags */}
              {(status !== "All Status" || service !== "All Services") && (
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="text-[11px] text-[#7D747F] font-semibold">Active:</span>
                  {status !== "All Status" && (
                    <span className="inline-flex items-center gap-1.5 bg-amber-50 text-amber-700 border border-amber-200 text-[11px] font-semibold px-2.5 py-1 rounded-full">
                      {status}
                      <button onClick={() => setStatus("All Status")} className="bg-transparent border-none cursor-pointer text-amber-500 hover:text-amber-700">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path strokeLinecap="round" d="M6 18L18 6M6 6l12 12" /></svg>
                      </button>
                    </span>
                  )}
                  {service !== "All Services" && (
                    <span className="inline-flex items-center gap-1.5 bg-violet-50 text-violet-700 border border-violet-200 text-[11px] font-semibold px-2.5 py-1 rounded-full">
                      {service}
                      <button onClick={() => setService("All Services")} className="bg-transparent border-none cursor-pointer text-violet-500 hover:text-violet-700">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path strokeLinecap="round" d="M6 18L18 6M6 6l12 12" /></svg>
                      </button>
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* Table */}
            <div className="bg-white rounded-[20px] shadow-[0px_8px_24px_rgba(75,35,100,0.04)] border border-[#F0EBF4] overflow-hidden">

              {/* Table Header */}
              <div className="grid grid-cols-5 px-6 py-4 bg-[#F9FAFB] border-b border-[#F0EBF4]">
                {["Ticket ID", "Subject", "Service", "Status", "Actions"].map((h) => (
                  <p key={h} className="text-[11px] font-bold text-[#7D747F] uppercase tracking-wider">{h}</p>
                ))}
              </div>

              {/* Loading */}
              {loadingTickets && (
                <div className="py-12 text-center text-[14px] text-[#7D747F]">Loading tickets...</div>
              )}

              {/* Rows */}
              {!loadingTickets && tickets
                .map((t, i, arr) => {
                  const statusKey = t.status?.toLowerCase();
                  const sStyle = statusKey === "open"
                    ? { text: "text-blue-600",    bg: "bg-blue-50",    border: "border-blue-200",    dot: "bg-blue-400" }
                    : statusKey === "in_progress"
                    ? { text: "text-amber-600",   bg: "bg-amber-50",   border: "border-amber-200",   dot: "bg-amber-400" }
                    : statusKey === "resolved"
                    ? { text: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", dot: "bg-emerald-400" }
                    : { text: "text-gray-600",    bg: "bg-gray-50",    border: "border-gray-200",    dot: "bg-gray-400" };
                  return (
                    <div key={t.ticket_id} className={`grid grid-cols-5 px-6 py-4 items-center hover:bg-[#FAFAFA] transition-colors ${i !== arr.length - 1 ? "border-b border-[#F3F4F5]" : ""}`}>
                      <div>
                        <p className="text-[14px] font-semibold text-[#34094D] font-inter">{t.ticket_id?.slice(0, 8).toUpperCase()}</p>
                        <p className="text-[10px] font-medium text-[#4C444E] mt-0.5">{t.created_at ? new Date(t.created_at).toLocaleDateString("en-IN") : "—"}</p>
                      </div>
                      <p className="text-[13px] text-[#191C1D] font-medium truncate pr-3">{t.subject}</p>
                      <p className="text-[14px] bg-[#34094D0D] w-fit rounded-full font-semibold text-[#34094D] truncate px-3 py-1">{t.service?.name || '—'}</p>
                      <span className={`inline-flex items-center gap-1.5 text-[11px] font-bold px-2.5 py-1 rounded-full w-fit border ${sStyle.bg} ${sStyle.text} ${sStyle.border}`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${sStyle.dot}`} />
                        {t.status?.replace("_", " ").toUpperCase()}
                      </span>
                      <button className="flex items-center gap-1.5 text-[12px] font-semibold text-[#4B2364] bg-[#4B2364]/10 hover:bg-[#4B2364]/20 px-3 py-1.5 rounded-lg border-none cursor-pointer transition-colors w-fit">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#4B2364" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/><circle cx="12" cy="12" r="3"/></svg>
                        View
                      </button>
                    </div>
                  );
                })
              }

              {/* Empty */}
              {!loadingTickets && tickets.length === 0 && (
                <div className="py-12 text-center">
                  <p className="text-[14px] text-[#7D747F] font-medium">No tickets found.</p>
                </div>
              )}
            </div>

            {/* Pagination */}
            {pagination && pagination.last_page > 1 && (
              <div className="flex items-center justify-center gap-3 mt-5">
                <button
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  disabled={page === 1}
                  className={`text-[12px] px-4 py-2 rounded-[10px] border border-gray-200 transition-colors ${page === 1 ? "bg-gray-50 text-gray-400 cursor-not-allowed" : "bg-white text-gray-700 hover:bg-gray-50 cursor-pointer"}`}
                >← Prev</button>
                <span className="text-[12px] text-[#7D747F]">Page {page} of {pagination.last_page}</span>
                <button
                  onClick={() => setPage(p => p + 1)}
                  disabled={!pagination.has_more}
                  className={`text-[12px] px-4 py-2 rounded-[10px] border border-gray-200 transition-colors ${!pagination.has_more ? "bg-gray-50 text-gray-400 cursor-not-allowed" : "bg-white text-gray-700 hover:bg-gray-50 cursor-pointer"}`}
                >Next →</button>
              </div>
            )}
          </div>
        )}
      </>
  );
}
